

function LiItemMobile({ link, text }) {
    return (
        <li className="mx-4 my-2 p-4
                       bg-slate-100 rounded shadow
                       text-slate-700 text-sm
                        hover:text-white
                        hover:cursor-pointer
                        hover:font-bold 
                        hover:bg-blue-800 "
        >
            <a href={link}>
                {text}
            </a>
        </li>
    )
}
export default LiItemMobile;